import { useHistory, useLocation, useParams, useRouteMatch } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { useSelector } from "react-redux";

import { MemberProfile } from "./MemberProfile";
import { patientDetailKeys } from "./api/keyFactory";
import { usePatientDetails } from "./api/queries/usePatientDetails";

// Once we refactor all Profile tabs to functional components this will be deprecated
export function MemberProfileContainer(props) {
  const { patientId } = useParams();
  const history = useHistory();
  const location = useLocation();
  const match = useRouteMatch();
  const queryClient = useQueryClient();
  const { data: patientDetails } = usePatientDetails({ patientId });
  const waitlistChangeCount = useSelector((state) => state.patient.waitlistChangeCount);

  if (!patientDetails) return null;

  const refetchPatientDetails = () =>
    queryClient.invalidateQueries({ queryKey: patientDetailKeys.details(patientId) });

  return (
    <MemberProfile
      {...props}
      history={history}
      location={location} // this replaces withRouter hoc
      match={match}
      patientDetails={patientDetails}
      refetchPatientDetails={refetchPatientDetails}
      waitlistChangeCount={waitlistChangeCount}
    />
  );
}
